import React, { useEffect, useState } from "react";
import "./HomePartners.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import schienderLogo from "./../../../vid_img/partners/schiender.png";
import adobeLogo from "./../../../vid_img/partners/adobe.png";
import capegeminiLogo from "./../../../vid_img/partners/capegemini.png";
import ciscoLogo from "./../../../vid_img/partners/cisco.png";
import dellLogo from "./../../../vid_img/partners/dell.png";
import hpLogo from "./../../../vid_img/partners/hp.png";
import ibmLogo from "./../../../vid_img/partners/ibm.png";
import infosysLogo from "./../../../vid_img/partners/infosys.png";
import ltLogo from "./../../../vid_img/partners/lt.png";
import panasonicLogo from "./../../../vid_img/partners/panasonic.png";
import samsungLogo from "./../../../vid_img/partners/samsung.png";
import simensLogo from "./../../../vid_img/partners/simens.png";
import tataLogo from "./../../../vid_img/partners/tata.png";
import wiproLogo from "./../../../vid_img/partners/wipro.png";
import kpmgLogo from "./../../../vid_img/partners/kpmg.png";
import abbLogo from "./../../../vid_img/partners/abb.png";
import cognizantLogo from "./../../../vid_img/partners/cognizant.png";
import accentureLogo from "./../../../vid_img/partners/accenture.png";
import hclLogo from "./../../../vid_img/partners/hcl.png";
import delliotLogo from "./../../../vid_img/partners/delliot.png";
import unileverLogo from "./../../../vid_img/partners/unilever.png";
import eyLogo from "./../../../vid_img/partners/ey.png";
import dhlLogo from "./../../../vid_img/partners/dhl.png";
import nestleLogo from "./../../../vid_img/partners/nestle.png";
import shellLogo from "./../../../vid_img/partners/shell.png";
import pgLogo from "./../../../vid_img/partners/pg.png";

const HomePartnersCard = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const [showDots, setShowDots] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setShowDots(window.innerWidth > 768); // Adjust the width as needed
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="homePartnersCard">
      <div className="homePartnersCardContent">
        <Carousel
          responsive={responsive}
          swipeable={true}
          draggable={true}
          showDots={showDots}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          customTransition="1s ease-in-out"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          <div>
            <div className="homePartnersCardItem">
              <img src={schienderLogo} alt="schiender Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={adobeLogo} alt="adobe Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={capegeminiLogo} alt="capegemini Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={ciscoLogo} alt="cisco Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={dellLogo} alt="dell Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={hpLogo} alt="hp Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={ibmLogo} alt="ibm Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={infosysLogo} alt="infosys Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={ltLogo} alt="lt Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={panasonicLogo} alt="panasonic Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={simensLogo} alt="simens Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={samsungLogo} alt="samsung Logo" loading="lazy" />
            </div>
          </div>
          <div>
            <div className="homePartnersCardItem">
              <img src={tataLogo} alt="tata Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={wiproLogo} alt="wipro Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={kpmgLogo} alt="kpmg Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={abbLogo} alt="abb Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={hclLogo} alt="hcl Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={accentureLogo} alt="acc Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={delliotLogo} alt="delliot Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={unileverLogo} alt="uni Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={eyLogo} alt="ey Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={dhlLogo} alt="dhl Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={nestleLogo} alt="nestle Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={shellLogo} alt="shell Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={cognizantLogo} alt="cog Logo" loading="lazy" />
            </div>
          </div>
           <div>
            <div className="homePartnersCardItem">
              <img src={pgLogo} alt="pg Logo" loading="lazy" />
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default HomePartnersCard;
